export function currentDay(){
    const date = new Date();

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");

    // This arrangement can be altered based on how we want the date's format to appear.
    let currentDate = `${year}-${month}-${day}`;
    return currentDate;
}
export function addDays(dateString, days) {
    // Parse the date string to a Date object
    let date = new Date(dateString);

    // Add the specified number of days
    date.setDate(date.getDate() + days);

    // Format the date back to a string (in the format YYYY-MM-DD)
    let year = date.getFullYear();
    let month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    let day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export function startOfMonth() {
    let date = new Date(currentDay());
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date.toISOString().split('T')[0];
}

export function endOfMonth() {
    let date = new Date(startOfMonth());
    date.setDate(date.getDate() + 31);
    date.setHours(23, 59, 59, 999);
    return date.toISOString().split('T')[0];
}